import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionCalendarService = {

    async getProductionProcess() {
        const requestScreenData = {
            url: "api/Process",
            filter: `IsCriticalProcess eq 'Y' and Inactive eq 'N'`,
            select: 'Code, Description ,Inactive, IsCriticalProcess'
        };

        return await ApiService.oDataGet(requestScreenData);
    },
}

export { ProductionCalendarService };